var newAccessTokenHandler = function (app) {
    var eventListener = function (event) {
        if (event && event.detail && event.detail.token) {
            app.ports.setNewAccessToken.send(event.detail.token);
        }
    };
    return {
        init: function () {
            window.addEventListener('accessTokenChanged', eventListener);
        },
        clear: function () {
            window.removeEventListener('accessTokenChanged', eventListener);
        }
    };
};
export default newAccessTokenHandler;
